<script setup>
import { computed, ref, watch } from "vue";
import { RouterView, useRoute } from "vue-router";
import GameCanvasHost from "@/components/GameCanvasHost.vue";
import { gameRuntimeBridge } from "@/game/bridge/runtimeBridge.js";

const route = useRoute();
const gameRouteActive = computed(() => route.name === "game");
const gameCanvasReady = ref(false);

watch(
  () => route.fullPath,
  () => {
    const snapshot = gameRuntimeBridge.getSnapshot();
    gameCanvasReady.value = Boolean(
      route.name === "game"
      && route.query.preloaded === "1"
      && snapshot?.screen === "playing"
      && Number(snapshot?.level) === Number(route.params.level)
    );
  },
  { flush: "sync" }
);
</script>

<template>
  <div class="app-shell">
    <!-- 游戏 Canvas 常驻挂载，避免旧游戏引擎重复绑定事件。路由只控制显隐和关卡。 -->
    <GameCanvasHost
      v-show="gameRouteActive && gameCanvasReady"
      @route-ready="gameCanvasReady = true"
    />

    <div
      v-if="gameRouteActive && !gameCanvasReady"
      class="game-route-loading"
      aria-label="Loading"
    >
      <span class="game-route-loading__ring" aria-hidden="true"></span>
    </div>

    <main v-if="!gameRouteActive" class="page-shell">
      <RouterView />
    </main>
  </div>
</template>

<style scoped>
.game-route-loading {
  position: fixed;
  inset: 0;
  z-index: 20;
  display: grid;
  place-items: center;
  background:
    radial-gradient(circle at 50% 42%, rgba(24, 194, 210, 0.16), transparent 34%),
    #031a2a;
}

.game-route-loading__ring {
  width: 46px;
  height: 46px;
  border: 4px solid rgba(114, 245, 241, 0.2);
  border-top-color: #72f5f1;
  border-radius: 50%;
  animation: game-route-spin 0.72s linear infinite;
}

@keyframes game-route-spin {
  to { transform: rotate(360deg); }
}
</style>
